var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIconOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.507,
    height: 27,
    viewBox: "0 0 31.507 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye-off",
    "data-name": "Icon ionic-md-eye-off",
    d: "M18.007,10.181a7.142,7.142,0,0,1,7.165,7.109,6.838,6.838,0,0,1-.513,2.6l4.184,4.148a16.809,16.809,0,0,0,4.915-6.75A16.968,16.968,0,0,0,12.291,7.622l3.094,3.073A7.084,7.084,0,0,1,18.007,10.181ZM3.684,6.307l3.27,3.241.661.654A16.729,16.729,0,0,0,2.25,17.29a16.993,16.993,0,0,0,22.029,9.464l.6.6,4.2,4.148L30.9,29.693,5.5,4.5ZM11.6,14.161l2.222,2.2a4.028,4.028,0,0,0-.113.921,4.275,4.275,0,0,0,4.3,4.261,4.041,4.041,0,0,0,.928-.112l2.222,2.2a7.127,7.127,0,0,1-10.315-6.356A7.023,7.023,0,0,1,11.6,14.161Zm6.173-1.1,4.514,4.479.028-.225a4.275,4.275,0,0,0-4.3-4.261Z",
    transform: "translate(-2.25 -4.5)",
    opacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconOff);
export default __webpack_public_path__ + "static/media/eyeIconOff.8d4b848487a82eb35141e2c2adc5fb0b.svg";
export { ForwardRef as ReactComponent };